<template>
  <div v-if="builds && builds.length > 0" class="mass-run-queue">
    <div class="mass-run-queue-titlebar">
      <span>Apps in diesem Vorgang</span>
      <strong>{{ builds.length }}</strong>
    </div>
    <ul class="list-group clear-list no-margins">
      <li v-for="(build, index) in builds" :key="build.id"
          class="list-group-item mass-run-queue-item">
        <div class="mass-run-queue-head">
          <div :class="{'text-muted': isWaitingBuild(build)}"
               class="mass-run-queue-title">
            <span class="mass-run-queue-index">{{ index + 1 }}</span>
            <span class="mass-run-queue-name">{{ getAppName(build.app_configuration_id) }}</span>
            <span class="mass-run-queue-meta">
              App ID: {{ getAppId(build.app_configuration_id) }} | Config ID: {{ build.app_configuration_id }}
            </span>
            <a :href="getConfigEditLink(build.app_configuration_id)" class="text-navy" target="_blank"
               title="Konfiguration bearbeiten">
              <i class="fa fa-external-link"></i>
            </a>
          </div>
          <div class="mass-run-queue-state">
            <span v-if="build.state === 9" class="text-success"><i class="fa fa-check-circle"></i></span>
            <span v-else-if="isFailed(build.state)" class="text-danger"><i class="fa fa-times-circle"></i></span>
            <span v-else-if="build.state === 10" class="text-warning"><i class="fa fa-ban"></i></span>
            <span v-else-if="isActiveBuild(build, run)" class="text-primary"><i
                class="fa fa-circle-o-notch fa-spin"></i></span>
            <span v-else-if="isWaitingBuild(build)" class="text-muted"><i
                class="fa fa-clock-o"></i></span>
          </div>
        </div>

        <div class="mass-run-step-row">
          <div class="mass-run-step">
            <i :class="getStepIcon(build, 'sync')" class="m-r-xs"></i>
            <small :class="getStepTextClass(build, 'sync')">Repo Sync</small>
          </div>
          <div class="mass-run-step-divider"><i class="fa fa-angle-right"></i></div>
          <div class="mass-run-step mass-run-step-build">
            <i :class="getStepIcon(build, 'build')" class="m-r-xs"></i>
            <small :class="getStepTextClass(build, 'build')">
              {{ getBuildPhaseText(build) }}
            </small>
            <a v-if="getCodemagicBuildUrl(build)"
               :href="getCodemagicBuildUrl(build)"
               class="mass-codemagic-link"
               target="_blank"
               title="Codemagic Build öffnen"
               @click.stop>
              <i class="fa fa-external-link"></i>
            </a>
          </div>
        </div>

        <div v-if="isActiveBuild(build, run)" class="progress progress-mini m-t-xs">
          <div :class="build.state === 15 ? 'progress-bar-info' : 'progress-bar-primary'"
               :style="{width: build.progress + '%'}"
               class="progress-bar progress-bar-striped active"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {getBuildPhaseText, getStepIcon, getStepTextClass, isFailed, isRunning, stateValue,} from './buildStates';

export default {
  props: {
    builds: {
      type: Array,
      required: true,
    },
    run: {
      type: Object,
      required: true,
    },
    configurations: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getAppName(configId) {
      const config = this.configurations.find(c => c.id === configId);
      return config ? config.app_name : 'Unbekannt';
    },
    getAppId(configId) {
      const config = this.configurations.find(c => c.id === configId);
      return config ? config.app_id : '-';
    },
    getConfigEditLink(configId) {
      return `/backend/app_configurations/${configId}/edit`;
    },
    isActiveBuild(build, run) {
      if (!run || run.status !== 'running') return false;
      return isRunning(build.state);
    },
    isWaitingBuild(build) {
      return stateValue(build.state) === 0;
    },
    isFailed(state) {
      return isFailed(state);
    },
    getStepIcon(build, step) {
      return getStepIcon(build, step);
    },
    getStepTextClass(build, step) {
      return getStepTextClass(build, step);
    },
    getBuildPhaseText(build) {
      return getBuildPhaseText(build);
    },
    getCodemagicBuildUrl(build) {
      if (!build || !build.codemagic_app_id || !build.codemagic_build_id) {
        return null;
      }

      return `https://codemagic.io/app/${build.codemagic_app_id}/build/${build.codemagic_build_id}`;
    },
  },
};
</script>
